import { render, staticRenderFns } from "./NufusCuzdaniForm.vue?vue&type=template&id=dd88ed34"
import script from "./NufusCuzdaniForm.vue?vue&type=script&lang=ts"
export * from "./NufusCuzdaniForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports